import { render, staticRenderFns } from "./ActionsItem.vue?vue&type=template&id=4764d1f7&scoped=true"
import script from "./ActionsItem.vue?vue&type=script&lang=js"
export * from "./ActionsItem.vue?vue&type=script&lang=js"
import style0 from "./ActionsItem.vue?vue&type=style&index=0&id=4764d1f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764d1f7",
  null
  
)

export default component.exports